<div class="authorization-info-container main-box-style">
     <div nz-flex nzAlign="center" nzGap="1rem">
        <h3>{{forEntityLabel() | translate}}</h3>
        <div class="values-container" nz-flex nzGap="1rem">
            @if(authDocumentInfo()) {
                <span>{{authDocumentInfo()?.ForLegal?.EntityName}}</span>
                <span>{{authDocumentInfo()?.ForLegal?.KeyDisplay}}</span>
            }@else {
                <span>{{forEntityName()}}</span>
                <span>{{forEntityKey()}}</span>
            }
        </div>
     </div>

     <div nz-flex nzAlign="center" nzGap="1rem">
        <h3>{{fromEntityLabel() | translate}}</h3>
        <div class="values-container" nz-flex nzGap="1rem">
            @if(authDocumentInfo()) {
                <span>{{authDocumentInfo()?.FromPerson?.EntityName || authDocumentInfo()?.FromPersonLegal?.EntityName}}</span>
                <span>{{authDocumentInfo()?.FromPerson?.KeyDisplay || authDocumentInfo()?.FromPersonLegal?.KeyDisplay}}</span>
            }@else {
                <span>{{fromEntityName()}}</span>
                <span>{{fromEntityKey()}}</span>
            }
        </div>
     </div>
</div>